// Milliseconds before Ontame stops waiting for a consent signal and stays off.
const CONSENT_TIMEOUT_MS = 5000;

// Unlike Ontame's standard loader, the page downloads the Ontame script only after statistics consent.
export const ontameScriptHTML = (
  tenant_id: string
) => `<script type="text/javascript">
    ; (function (p, i) { if (!p[i]) { p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []; p.GlobalSnowplowNamespace.push(i); p[i] = function () { (p[i].q = p[i].q || []).push(arguments) }; p[i].q = p[i].q || []; } }(window, 'ontame'));
    const matchDomains = ['hr-manager.net', 'reachmee.com', '.webcruiter.'];
    const matchFunction = linkElement => matchDomains.some(domain => linkElement.href.includes(domain));

    function loadOntameScript() {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://cdn.ontame.io/3.4.0/skYkappS.js';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    function clearOntameQueue() {
      try {
        window.localStorage.removeItem('snowplowOutQueue_ontame_clj_post2');
        window.localStorage.removeItem('snowplowOutQueue_ontame_clj_post2.expires');
      } catch (e) {}
    }

    let ontameConsentHandled = false;
    function initOntame(statistics) {
      if (ontameConsentHandled) return;
      ontameConsentHandled = true;
      if (statistics) {
        loadOntameScript();
        window.ontame('newTracker', 'clj', 'collector.ontame.io',
          {
            appId: "${tenant_id}",
            cookieName: 'ontame_',
            cookieSameSite: 'Lax',
            discoverRootDomain: true,
            cookieLifetime: 86400 * 365,
            crossDomainLinker: matchFunction
          }
        );
        window.ontame('trackPageView');
      }
    }

    function handleOntameConsent(statistics) {
      if (!statistics) clearOntameQueue();
      initOntame(statistics);
    }

    window.addEventListener('CookiebotOnConsentReady', function (e) {
      handleOntameConsent(!!Cookiebot.consent.statistics);
    }, false);

    window.addEventListener('talentech:consentReady', function (e) {
      handleOntameConsent(!!(e.detail && e.detail.statistics));
    }, false);

    setTimeout(function () { initOntame(false); }, ${CONSENT_TIMEOUT_MS});

    </script>`;

export const ontameJobIdTrackEventHTML = () => `<script type="text/javascript">
    let jobTrackConsentHandled = false;
    function applyJobConsent(statistics) {
      if (jobTrackConsentHandled) return;
      jobTrackConsentHandled = true;
      if (statistics) {
        window.ontame('trackStructEvent', { category: 'job', action: 'jobView', label: "{ATS_ID}" });
      }
    }

    window.addEventListener('CookiebotOnConsentReady', function (e) {
      applyJobConsent(Cookiebot.consent.statistics);
    }, false);

    window.addEventListener('talentech:consentReady', function (e) {
      applyJobConsent(!!(e.detail && e.detail.statistics));
    }, false);

    setTimeout(function () { applyJobConsent(false); }, ${CONSENT_TIMEOUT_MS});
    </script>`;
